import axios from '../axiosConfig'; 

const addAddress = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.post('/logistics/address/add', {...data}, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  };

const modifyAddress = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.get(`/logistics/address/modify/${data.address_id}`, {...data}, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) {
      return error;
    }
  };

const getAddress = async (address_id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.get(`/logistics/address/address_id=${address_id}`, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) {
      console.error('Error get address:', error);
      return null;
    }
  };

const fetchSavedAddressList = async () => {
    /*
    {
      "status": true,
      "success": true,
      "message": "All addresses retrieved successfully",
      "addresses": [
        {
          "id": 1,
          "user_id": 1,
          "full_name": "John Doe",
          "address_line1": "123 Main St",
          "address_line2": "Apt 4B",
          "city": "New York",
          "state": "NY",
          "country": "USA",
          "postal_code": "10001",
          "phone_number": "+1-555-123-4567",
          "is_default": true,
          "created_at": "2025-02-04T20:23:42.924246",
          "address_type": "home"
        }
      ]
    }
    */
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.get('/logistics/address/all', {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) {
      console.error('Error fetching address list:', error);
      return null;
    }
  };


export { addAddress, getAddress, modifyAddress, fetchSavedAddressList };
